import { camelCase } from 'lodash';
import { createSelector } from 'reselect';
import { sceneParams } from '../data/data.sceneParams';
import { raw } from './selectors.raw';
import * as single from './selectors.single';
import { parametersWithValues } from './utils/parameters';

const $i = (state: any) => state;

export const $parameters = createSelector(single.$currentGenerator, (generator) => {
  if (!generator) return [];

  const { parameters, groups } = generator as IGenerator;

  groups.forEach((group) => {
    // @ts-ignore
    const { isToggleable } = group;

    if (isToggleable) {
      parameters.unshift({
        id: `${camelCase(group.id)}.enabled`,
        name: 'Enabled',
        groupId: group.id,
        type: 'toggle',
      });
    }
  });

  return [...parameters];
});

export const $groups = createSelector(single.$currentGenerator, (generator) => {
  if (!generator) return [];

  const { groups } = generator as IGenerator;

  return groups ?? [];
});

export const $parametersWithValues = createSelector(
  $groups,
  $parameters,
  raw.$rawValuesModel,
  (groups, parameters, values) => {
    return parametersWithValues(groups, parameters, values);
  }
);

export const $parametersScene = createSelector(raw.$rawRealtimeState, (realtimeState) => {
  return parametersWithValues(sceneParams.groups, sceneParams.parameters, realtimeState);
});

export const $soda = createSelector(
  raw.$rawGenerators,
  raw.$rawModel,
  raw.$rawValuesModel,
  (generators, model, values) => {
    if (!model) return {};

    const { generatorId } = model;
    const generator = generators[generatorId];

    if (!generator || !generator.parameters) return {};

    const { parameters } = generator;

    return Object.values(parameters).map((p) => {
      const { id, defaultValue, options = [], type } = p;
      let value = values[id] || defaultValue || 0;

      if (type === 'toggle') {
        return {
          Name: id,
          DefaultValue: value ? 1 : 0,
          IsInt: true,
          MinValue: 0,
          MaxValue: 1,
        };
      } else if (type === 'slider') {
        return {
          Name: id,
          DefaultValue: value,
          IsInt: false,
          MinValue: 0,
          MaxValue: 1,
        };
      } else if (type === 'picker') {
        value = options.indexOf(value as any);
        return {
          Name: id,
          Options: options,
          CurrentValue: value,
        };
      }
    });
  }
);
